import { axios, axios2 } from '@/lib/axios';

export const postSubscription = (id: any, ptoken: any, netAmount: string) => {
  const payload = {
    subscription_id: id,
    payment_token: ptoken,
    price: netAmount,
  };
  return axios2.post('/subscription-api/purchase-subscription-plan', payload);
};
